import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Job} from '../domain/job';
import {JobsService} from '../services/jobs.service';
import {ResourcesService} from '../services/resource.service';
import {MultiSelect} from 'primeng/multiselect';
import {SelectItem} from 'primeng/api';
import {Router} from '@angular/router';
import * as _ from 'underscore';
import {JOB_DEFINITION_PAGE, SharedDataService } from '../services/shared-data.service';
import {StorageService} from '../services/storage.service';
import {ArticleService} from '../services/article.service';
import {Article} from '../domain/article';
import {Table} from 'primeng/table';
import {AuthenticationGuard} from '../oauth/authentication.guard';
import {ActiveJobs} from '../domain/activeJobs';
import { forkJoin } from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import { JobLog } from '../domain/JobLog';


@Component({
    selector: 'app-active-jobs',
    templateUrl: './active-jobs.component.html',
    styleUrls: ['./active-jobs.component.css'],
    standalone: false
})
export class ActiveJobsComponent implements OnInit, OnDestroy {


  jobs: Job[];
  application: string;
  location: string;
  resource: string;

  selectedUser: string;
  selectedType: string;


  jobNames: SelectItem[];
  jobStatus: SelectItem[];
  jobUsers: SelectItem[];
  jobNumbers: SelectItem[];
  authNames: SelectItem[];
  subSystems: SelectItem[];
  systems: SelectItem[];
  userOptions: SelectItem[];
  types: SelectItem[];

  activeJobs: ActiveJobs[];

  activeJobLog: ActiveJobs=undefined;

  logdisplay:boolean = false;

  joblogs: JobLog[]=undefined;

  applications: SelectItem[];
  resources: SelectItem[];
  statusOptions: SelectItem[];
  subSystemsOptions: SelectItem[];
  systemsOptions: SelectItem[];
  data: string[];
  msgs: any[] = [];
  isFilterApp: boolean;
  selectedJob: Job;
  selectedActiveJob: ActiveJobs;
  filters: string;

  counterLower: number;
  counterHigher: number;
  counter100: number;
  graphicHidden: boolean;
  labels: string[];
  jobEndedOk: number[];
  jobNotOk: number[];
  jobRunning: number[];
  i: number;
  idToken;
  article: Article;
  displayHelp: any;
  cols: any[];
  timer: any;
  timer_interval: any;
  statSec: number;
  display: any;
  csvCols: any[];

  selectedLocation: string;
  selectedAppFullName: string[];
  selectedJobName: string;
  selectedJobUser: string;
  selectedJobNumber: string;
  selectedAuthName: string;
  selectedSubSystem: string [];
  selectedSystem: string [];
  selectedDescription: string;
  selectedStatus: string [];
  selectedStartDate: Date;

  loading= false;
  @ViewChild(('dt'), { static: true }) dtTable: Table;
  @ViewChild('ms', { static: false }) multiselect: MultiSelect;
  allItems: ActiveJobs [];
  allSystems: string[];
  selectedRowData: { selectedStartDate: any; selectedJobName: string; selectedAppFullName: any[]; selectedLocation: string; selectedStatus: any[]; selectedDescription: string; resource: string; };
  viewlog: { dataLog: any; jobDetails: string; rowData: any; selectedRowDetail: any; };

  constructor(private readonly jobsService: JobsService, private readonly resourcesService: ResourcesService,
    private readonly router: Router, private readonly sharedDataService: SharedDataService,
    private readonly storageService: StorageService,
    private readonly authorizationService: AuthenticationGuard,
    private readonly articleService: ArticleService, public readonly dialog: MatDialog) {
    this.isFilterApp = true;
    this.filters = 'Show Filters';
  }

  ngOnInit() {
    this.authorizationService.checkLogin();
    this.selectedAppFullName = null;
    this.selectedLocation = null;
    this.selectedJobName = null;
    this.selectedJobUser = null;
    this.selectedJobNumber = null;
    this.selectedAuthName = null;
    this.selectedSubSystem = [];
    this.selectedSystem = []
    this.selectedDescription = null;
    this.selectedStatus = [];
    this.selectedStartDate = null;
    this.jobNames = [];
    this.jobStatus = [];
    this.jobUsers = [];
    this.authNames = [];
    this.jobNumbers = [];
    this.subSystems = [];
    this.systems = [];
    this.statusOptions = [];
    this.subSystemsOptions = [];
    this.systemsOptions = [];
    this.timer = null;
    this.timer_interval = null;
    this.allItems = [];
    this.activeJobs = [];

    this.selectedUser = null;
    this.selectedType = null;

    this.graphicHidden = true;
    this.resources = [];
    this.labels = [];
    this.countdown_Timer(1);
    this.getResources();
    
    this.statSec = 60;
    this.counter100 = 0;
    this.counterHigher = 0;
    this.counterLower = 0;
    this.jobEndedOk = [];
    this.jobNotOk = [];
    this.jobRunning = [];
    this.jobs = [];
    this.displayHelp = false;
    this.article = {text: '', title: ''};

    this.cols = [

      {field: 'name', header: 'Name', width: '8%'},
      {field: 'jobUser', header: 'User', width: '6%'},
      {field: 'jobNumber', header: 'Number', width: '6%'},
      {field: 'status', header: 'Status', width: '6%'},
      {field: 'authName', header: 'Auth Name', width: '6%'},
      {field: 'subSystem', header: 'Sub System', width: '6%'},
      {field: 'percentage', header: 'CPU %', width: '4%'},
      {field: 'system', header: 'System', width: '6%'},
      { field: 'action', header: 'Action', width: '7%' }
    ];

    this.csvCols = [
      {field: 'jobName', header: 'Job Name'},
      {field: 'jobUser', header: 'Job User'},
      {field: 'jobNumber', header: 'Job Number'},
      {field: 'jobStatus', header: 'Job Status'},
      {field: 'authorizationName', header: 'Authorization Name'},
      {field: 'subSystem', header: 'Sub System'},
      {field: 'percent', header: 'CPU Percentage'},
      {field: 'system', header: 'System'}
    ];
    
    this.statusOptions = [
      {label:'BSCA',value:'BSCA',title:'BSCA'},
      {label:'BSCW',value:'BSCW',title:'BSCW'},
      {label:'CMNA',value:'CMNA',title:'CMNA'},
      {label:'CMNW',value:'CMNW',title:'CMNW'},
      {label:'CMTW',value:'CMTW',title:'CMTW'},
      {label:'CNDW',value:'CNDW',title:'CNDW'},
      {label:'CPCW',value:'CPCW',title:'CPCW'},
      {label:'DEQA',value:'DEQA',title:'DEQA'},
      {label:'DEQW',value:'DEQW',title:'DEQW'}, 
      {label:'DKTA',value:'DKTA',title:'DKTA'},
      {label:'DKTW',value:'DKTW',title:'DKTW'},
      {label:'DLYW',value:'DLYW',title:'DLYW'},
      {label:'DSC',value:'DSC',title:'DSC'},
      {label:'DSPA',value:'DSPA',title:'DSPA'},
      {label:'DSPW',value:'DSPW',title:'DSPW'},
      {label:'END',value:'END',title:'END'},
      {label:'EOFA',value:'EOFA',title:'EOFA'},
      {label:'EOFW',value:'EOFW',title:'EOFW'},
      {label:'EOJ',value:'EOJ',title:'EOJ'},
      {label:'EVTW',value:'EVTW',title:'EVTW'},
      {label:'GRP',value:'GRP',title:'GRP'},
      {label:'HLD',value:'HLD',title:'HLD'},
      {label:'HLDT',value:'HLDT',title:'HLDT'},
      {label:'ICFA',value:'ICFA',title:'ICFA'},
      {label:'ICFW',value:'ICFW',title:'ICFW'},
      {label:'INEL',value:'INEL',title:'INEL'},
      {label:'JVAA',value:'JVAA',title:'JVAA'},
      {label:'JVAW',value:'JVAW',title:'JVAW'},
      {label:'LCKW',value:'LCKW',title:'LCKW'},
      {label:'LSPA',value:'LSPA',title:'LSPA'},
      {label:'LSPW',value:'LSPW',title:'LSPW'},
      {label:'MLTA',value:'MLTA',title:'MLTA'},
      {label:'MLTW',value:'MLTW',title:'MLTW'},
      {label:'MSGW',value:'MSGW',title:'MSGW'},
      {label:'MTXW',value:'MTXW',title:'MTXW'},
      {label:'MXDW',value:'MXDW',title:'MXDW'},
      {label:'OPTA',value:'OPTA',title:'OPTA'},
      {label:'OPTW',value:'OPTW',title:'OPTW'},
      {label:'OSIW',value:'OSIW',title:'OSIW'},
      {label:'PRTA',value:'PRTA',title:'PRTA'},
      {label:'PRTW',value:'PRTW',title:'PRTW'},
      {label:'PSRW',value:'PSRW',title:'PSRW'},
      {label:'RUN',value:'RUN',title:'RUN'},
      {label:'SELW',value:'SELW',title:'SELW'},
      {label:'SEMW',value:'SEMW',title:'SEMW'},
      {label:'SIGS',value:'SIGS',title:'SIGS'},
      {label:'SIGW',value:'SIGW',title:'SIGW'},
      {label:'SRQ',value:'SRQ',title:'SRQ'},
      {label:'SVFA',value:'SVFA',title:'SVFA'},
      {label:'SVFW',value:'SVFW',title:'SVFW'},
      {label:'TAPA',value:'TAPA',title:'TAPA'},
      {label:'TAPW',value:'TAPW',title:'TAPW'},
      {label:'THDW',value:'THDW',title:'THDW'},
      {label:'TIMA',value:'TIMA',title:'TIMA'},
      {label:'TIMW',value:'TIMW',title:'TIMW'}
    ];
    
  }
  ngOnDestroy() {
    this.resource=null;
    clearInterval(this.timer);
  }

  onLoadTable(): void {
    // Filter data
    //Filter by Job Name
    if (this.sharedDataService.selectedJobName) {
      this.selectedJobName = this.sharedDataService.selectedJobName;
      this.listJobNames();
      this.dtTable.filter(this.sharedDataService.selectedJobName, 'jobName', 'contains');
    }
    //Filter by jobUser
    if (this.sharedDataService.selectedJobUser) {
      this.selectedJobUser = this.sharedDataService.selectedJobUser;
      this.listJobUsers();
      this.dtTable.filter(this.sharedDataService.selectedJobUser, 'jobUser', 'contains');
    }
    //Filter by jobNumber
    if (this.sharedDataService.selectedJobNumber) {
      this.selectedJobNumber = this.sharedDataService.selectedJobNumber;
      this.listJobNumbers();
      this.dtTable.filter(this.sharedDataService.selectedJobNumber, 'jobNumber', 'contains');
    }
    //Filter by AuthName
    if (this.sharedDataService.selectedAuthName) {
      this.selectedAuthName = this.sharedDataService.selectedAuthName;
      this.listAuthNames();
      this.dtTable.filter(this.sharedDataService.selectedAuthName, 'authName', 'contains');
    }
    //Filter by SubSystem
    if (this.sharedDataService.selectedSubSystem) {
      this.selectedSubSystem = this.sharedDataService.selectedSubSystem;
      this.listSubSystems();
      this.dtTable.filter(this.sharedDataService.selectedSubSystem, 'subSystem', 'contains');
    }
    //Filter by Status
    if (this.sharedDataService.selectedStatus) {
      this.selectedStatus = this.sharedDataService.selectedStatus;
      this.listJobStatus();
      this.dtTable.filter(this.sharedDataService.selectedStatus, 'status', 'contains');
    }
    //Filter by Systems
    if (this.sharedDataService.selectedSystem) {
      this.selectedSystem = this.sharedDataService.selectedSystem;
      this.listSystems();
      this.dtTable.filter(this.sharedDataService.selectedSystem, 'system', 'contains');
    }

    if (this.sharedDataService.selectedAppFullName != null || this.sharedDataService.selectedLocation != null || this.sharedDataService.selectedJobName != null || this.sharedDataService.selectedJobUser != null || this.sharedDataService.selectedDescription
      || this.sharedDataService.selectedStatus != null || this.sharedDataService.selectedStartDate != null) {
      this.onFilterButtonClick();
    }
    this.sharedDataService.flushJobData();
  }

  eventsAfterGetting(){
          this.graphicHidden = false;
          this.onLoadTable();
          this.subSystemsOptions = [];
          this.systemsOptions = [];
          let jobArray: string[] = [];
          this.activeJobs.filter(job => {
            return job.jobName != null;
          })
            .forEach(job => {
              jobArray = job.jobName.split('/');
              job.jobNumber = jobArray[0];
              job.jobUser = jobArray[1];
              job.jobName = jobArray[2];
            });
          //add systems to activeJobs if its undefined
          this.activeJobs
            .filter(job => {
              return job.system == undefined;
          })
            .forEach(job => {
            job.system = this.resource
          });
          //Select distinct of Status received and subSystems received.
          this.activeJobs
            .filter(job => {
              return job.jobStatus != null;
            })
            .forEach(job => {
                //If status is not currently in the list, it is added (Distinct)
                // if (_.findLastIndex(this.statusOptions, {label: job.jobStatus.trim(), value: job.jobStatus.trim()}) < 1) {
                //   this.statusOptions.push({label: job.jobStatus.trim(), value: job.jobStatus.trim()});
                // }
                //If subSystems is not currently in the list, it is added(Distinct)
                if (_.findLastIndex(this.subSystemsOptions, {label: job.subSystem.trim(), value: job.subSystem.trim()}) < 1) {
                  this.subSystemsOptions.push({label: job.subSystem.trim(), value: job.subSystem.trim()});
                }
                //If Systems is not currently in the list, it is added(Distinct)
                if (_.findLastIndex(this.systemsOptions, {label: job.system.trim(), value: job.system.trim()}) < 1) {
                  this.systemsOptions.push({label: job.system.trim(), value: job.system.trim()});
                }
              }
            );
          // Remove duplicates
          // const uniqueStatus = Array.from(new Set(this.statusOptions.map(a => a.label)))
          //   .map(id => {
          //     return this.statusOptions.find(a => a.label === id);
          //   });
          // Remove Subsytems duplicates
          const uniqueSubSystems = Array.from(new Set(this.subSystemsOptions.map(a => a.label)))
            .map(id => {
              return this.subSystemsOptions.find(a => a.label === id);
            });
          // Remove sytems duplicates
          const uniqueSystems = Array.from(new Set(this.systemsOptions.map(a => a.label)))
            .map(id => {
              return this.systemsOptions.find(a => a.label === id);
            });
          
          this.subSystemsOptions = uniqueSubSystems;
          this.systemsOptions = uniqueSystems;

          if(this.selectedStatus.length>=1){
            //this.selectedStatus.filter(s=>s.indexOf['MSGW']>=0)
            this.dtTable.filter(this.selectedStatus,'jobStatus','in');
          }else{
            this.selectedStatus=['MSGW'];
            this.dtTable.filter(['MSGW'],'jobStatus','in');
          }
  }
  getJobs(resource: string) {
    // THIS IS FOR SKELETON PURPOSES , CHANGE JobService call (getJobs) to call needed endpoint for ACTIVE_JOB
    if (resource === 'All') {

      this.graphicHidden = true;
      setTimeout(() => {
        this.activeJobs = this.allItems;
        this.eventsAfterGetting();
      }, 5000);
      
    } else {
      let userID = this.storageService.getItem("userId");
      console.log(userID);
      this.jobsService.getAllActiveStatusJobs(resource,userID).subscribe({
        next: activeJobs => {
          this.graphicHidden = false;
          this.activeJobs = activeJobs;
          this.onLoadTable();
        },
        error: error => {
          console.error('Error retrieving Active Jobs ' + error);
        },
        complete: () => {
          this.eventsAfterGetting();
        }
      });
    }

  }


  getResources(): void {
    // GETS ACTIVE RESOURCES
    this.idToken = this.storageService.getItem('encodedAccessToken');
    setTimeout(() => {

      this.resourcesService.getResources(this.idToken)
        .subscribe({
          next: resources => {
            this.data = resources;
          },
          error: error => {
            console.error('Error retrieving resource systems' + error);
            this.resources.push({label: 'AS400-AAA', value: 'AS400-AAA'});
            // In case authError the AAA data is retrieved
          },
          complete: () => {
            this.resources = this.data.map((item) => ({label: item, value: item }));

            this.resources.push({label: 'All', value: 'All'});
            // If resource is informed in sharedDataService, meaning the user clicked on Go Back on details section,
            // then, that resource is loaded. If not, default value is loaded
            if (this.sharedDataService.resource) {
              this.resource = this.sharedDataService.resource;
            } else {
              this.resource = this.resources[0].value;
            }
            this.getJobs(this.resource);
            if (this.resource == 'All') {
              this.AllResources();
            }
          }
        });
    });
  }

  AllResources():void {
    this.allItems = [];
    this.graphicHidden = true;
    let userID: string = "";
    for (const system of this.data) {
      userID = this.storageService.getItem("userId");
      console.log(userID);
      forkJoin(this.jobsService.getAllActiveStatusJobs(system, userID)).subscribe({
        next: items => {
          items.forEach(k => {
            k.forEach(j => {
              if (j.jobName != null) {
                j.system = system;
              }
              this.allItems.push(j);
            });
          });
        }
      });
    }
  }
  
  countdown_Timer(minute: any): void {
    let textSec: any = '0';
    this.statSec = minute * 60;//59

    this.timer_interval = setInterval(() => {
      
      if (this.statSec != 0) {
        this.statSec--;
      } else {
        this.statSec = 59;
      }

      if (this.statSec < 10) {
        textSec = '0' + this.statSec;
      } else {
        textSec = this.statSec;
      }

      this.display = `${textSec}`;
      if (this.statSec == 0) {
        this.onReloadTable(this.dtTable);
      }
    }, 1000);
  }

  goDetails(selectedJob: any): void {
    this.sharedDataService.insertActiveJobData(this.selectedJobName, this.selectedStatus, this.selectedJobUser, this.selectedJobNumber, this.selectedAuthName, this.selectedSubSystem, this.selectedSystem);
    this.router.navigate([JOB_DEFINITION_PAGE]);
  }


  onFilterButtonClick() {
    if (this.isFilterApp) {
      this.isFilterApp = false;
      this.filters = 'Hide Filters';
    } else {
      this.isFilterApp = true;
      this.filters = 'Show Filters';
    }
  }

  resourceSelected(dt: any): void {
    this.activeJobs = [];
    this.isFilterApp = false;
    this.onFilterButtonClick();
    this.selectedStatus = [];
    if (dt) {
      dt.reset();
      this.onReloadTable(dt);
    }
  }

  onReloadTable(dt: any): void {
    if (this.resource != null) {
      this.graphicHidden = true;
      if(this.resource == 'All'){
        this.AllResources();
      }
      clearInterval(this.timer_interval);
      this.countdown_Timer(1);
      this.getJobs(this.resource);
    } else {
      this.msgs.push({severity: 'error', summary: 'Info Message', detail: 'No resource selected'});
    }
    

  }
  showJobLogs(rowData): void {

    this.loading= true;

    this.sharedDataService.rowData = rowData;

    this.jobsService.getActiveJobLogs(rowData.jobName, rowData.jobUser, rowData.jobNumber, rowData.system)
      .subscribe(data => {
      
        this.loading= false;

        this.sharedDataService.joblogs = data;

        console.log(rowData)

        this.activeJobLog=rowData;

        this.joblogs = data;

        this.logdisplay = true;
      });
  }


  private listJobNames() {
    this.jobNames = [];
    this.activeJobs.forEach(job => {
      if (_.findLastIndex(this.jobNames, {label: job.jobName, value: job.jobName}) < 1) {
        this.jobNames.push({label: job.jobName, value: job.jobName});
      }
    });
  }
  private listJobStatus() {
    this.jobStatus = [];
    this.activeJobs.forEach(job => {
      if (_.findLastIndex(this.jobStatus, {label: job.jobStatus, value: job.jobStatus}) < 1) {
        this.jobStatus.push({label: job.jobStatus, value: job.jobStatus});
      }
    });
  }
  
  private listJobUsers() {
    this.jobUsers = [];
    this.activeJobs.forEach(job => {
      if (_.findLastIndex(this.jobUsers, {label: job.jobUser, value: job.jobUser}) < 1) {
        this.jobUsers.push({label: job.jobUser, value: job.jobUser});
      }
    });
  }
  private listJobNumbers() {
    this.jobNumbers = [];
    this.activeJobs.forEach(job => {
      if (_.findLastIndex(this.jobNumbers, {label: job.jobNumber, value: job.jobNumber}) < 1) {
        this.jobNumbers.push({label: job.jobNumber, value: job.jobNumber});
      }
    });
  }
  private listAuthNames() {
    this.authNames = [];
    this.activeJobs.forEach(job => {
      if (_.findLastIndex(this.authNames, {label: job.authorizationName, value: job.authorizationName}) < 1) {
        this.authNames.push({label: job.authorizationName, value: job.authorizationName});
      }
    });
  }
  private listSubSystems() {
    this.subSystems = [];
    this.activeJobs.forEach(job => {
      if (_.findLastIndex(this.subSystems, {label: job.subSystem, value: job.subSystem}) < 1) {
        this.subSystems.push({label: job.subSystem, value: job.subSystem});
      }
    });
  }
  private listSystems() {
    this.systems = [];
    this.activeJobs.forEach(job => {
      if (_.findLastIndex(this.systems, {label: job.system, value: job.system}) < 1) {
        this.systems.push({label: job.system, value: job.system});
      }
    });
  }
  getJobId(rowDatum: any) {
    return rowDatum.replace(/^0+/, '');
  }

  statusIconHandler(status: string): string {
    if (status.indexOf('MSGW') >= 0 || status.indexOf('LCKW') >= 0) {
      return 'fa fa-close';
    } else {
      return 'fa fa-warning';
    }
  }

  download() {
    setTimeout(() => {
      let csvData = "";
      let msg1 = '';
      let msg2 ='';
      for (let log of this.joblogs) {
        if(log.messageText != null && log.messageText != undefined && log.messageText!= 'null')
                msg1 = log.messageText;
       if(log.messageSecondLevelText != null && log.messageSecondLevelText != undefined && log.messageSecondLevelText!= 'null')
                msg2 = "\r\t" +log.messageSecondLevelText;

       csvData += msg1+"\n" + msg2;
       msg1 = '';
       msg2 ='';
      }
      let a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      let blob = new Blob([csvData], { type: 'application/octet-stream' });
      let url = window.URL.createObjectURL(blob);
      a.href = url;
      let x: Date = new Date();
      // File name
      let link: string = this.activeJobLog.jobName + "_" 
                        + this.activeJobLog.jobUser + "_" 
                        + this.activeJobLog.jobNumber + "_" 
                        + x.getMonth() + "_" 
                        + x.getDate() + "_" 
                        + x.getFullYear() + "_" 
                        + x.getHours() + "_" 
                        + x.getMinutes() + "_" 
                        + x.getSeconds() + '.log';
                        
      a.download = link.toLocaleLowerCase();
      a.click();
    });
  }
}